module.exports = __webpack_public_path__ + "img/Category.a16dc09e.svg";